import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, ValidateNested } from "class-validator";

export default class GetRequestsForPaymentListItem {
  @IsString()
  @Expose()
  id!: string; // "66a28f60-8bf4-4b60-be6e-10e9f801a02d",
  @IsString()
  @Expose()
  documentNumber!: string; // "Przedsądowe wezwanie do zapłaty",
  @IsString()
  @Expose()
  contractor!: string; // "PRO-AIR  Sp. z o.o.",
  @IsString()
  @Expose()
  currency!: string; // "PLN",
  @IsString()
  @Expose()
  issueDate!: string; // "2020-01-17T00:00:00",
  @IsNumber()
  @Expose()
  gross!: number; // 19979.84
}

export class GetRequestsForPaymentListResponse extends GenericTableResponse<GetRequestsForPaymentListItem> {
  @Type(() => GetRequestsForPaymentListItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
      // @ts-ignore
  items!: Array<GetRequestsForPaymentListItem>;
}
